<template>
  <div class="msg-container">
    <check-animate />
    {{ msg }}
  </div>
</template>

<script>
import CheckAnimate from '@/components/CheckAnimate'
export default {
  components: {
    CheckAnimate
  },
  data () {
    return {
      msg: '完成注册'
    }
  },
  methods: {
    updateLogin (obj) {
      this.$emit('updateLogin', obj)
    }
  },
  created () {
    setTimeout(() => {
      this.updateLogin({
        formType: null
      })
    }, 5000)
  }
}
</script>

<style lang="scss" scoped>
.msg-container {
  margin-top: -20px;
  color: #494949;
  font-size: 18px;
  font-weight: 500;
}
</style>
